import React, { useState, useEffect, useRef } from 'react';

import { store } from "react-notifications-component";

import Solicitar from '../../pages/solicitar';

import Interruptor from '../interruptor';
import Button from '../button/button_v2';
import ButtonAddNew from '../buttonAddNew';
import ModalAlert from '../modal/modalGeneric';

import IconHelp from '../../assets/icons/help';
import ArrowIcon from "../../assets/icons/icon-arrow.svg";
import DeleteIcon from "../../assets/icons/icon-delete.svg";
import SearchIcon from "../../assets/icons/icon-search-black.svg";
import IconInputClose from '../../assets/icons/icons-close-gray.svg';
import { filterAndRankOptions } from '../../services/textSearch';

import {
    SelectContainerV2,
    Label,
    Arrow,
    Clearabled,
    Plus,
    Legenda,
    Options,
    Option,
    OptionLabel,
    OptionCommonNames,
    OptionScientificName,
    NoOptions,
    YesNoContainer,
    YesNoContainerMobile,
    Loading
} from './styles_select_v2_step_one';
import * as S from './styles_select_v2_step_one'
import { theme } from '../../styles/theme';

export const USER = "@userinfo";

const SelectV2StepOne = ({ ...props }) => {
    const [ref] = useState(useRef());
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState('');
    const [selectOptions, setSelectOptions] = useState([]);
    const [yesNoValue, setYesNoValue] = useState(true);

    const [solicitaP, setSolicitaP] = useState(false);
    const [showModalSolicitar, setModalSolicitar] = useState(false);
    const [showModalBlock, setModalBlock] = useState(false);

    const [addOptions, setAddOptions] = useState(false);
    const [limit, setLimit] = useState(20);

    const [isclose, setisclose] = useState(false);

    /**
     * Separa o label "nomes comuns - nome científico" para estilizar cada parte.
     * Usa os campos vindos da API quando a opção os traz; senão recorta pelo
     * último " - ".
     */
    const splitOptionLabel = (op) => {
        const label = `${op.label ?? ''}`;
        const scientificName = `${op.nome_cientifico ?? ''}`;

        const separatorIndex = scientificName && label.endsWith(scientificName)
            ? label.lastIndexOf(` - ${scientificName}`)
            : label.lastIndexOf(' - ');

        if (separatorIndex === -1) return null;

        const commonNames = label.slice(0, separatorIndex).trim();
        const scientific = label.slice(separatorIndex + 3).trim();
        if (!commonNames || !scientific) return null;

        return { commonNames, scientificName: scientific };
    };

    const renderOptionLabel = (op) => {
        const parts = props.highlightScientificName ? splitOptionLabel(op) : null;
        if (!parts) return op.label;

        return (
            <OptionLabel>
                <OptionScientificName>{parts.scientificName}</OptionScientificName>
                <OptionCommonNames>{parts.commonNames}</OptionCommonNames>
            </OptionLabel>
        );
    };

    const onChange = (valueOp) => {
        if (value) {
            if (value.value !== valueOp.value) {
                if (props.isSearch === true) {
                    if (valueOp.value != props.value) {
                        props.onChange(valueOp);
                        setValue(valueOp);
                        setIsOpen(false);
                    } else {
                        setValue(valueOp);
                    }
                } else {
                    props.onChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                }
            }
        } else {
            if (props.isSearch === true) {
                if (valueOp.value != props.value) {
                    props.onChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                } else {
                    setValue(valueOp);
                }
            } else {
                props.onChange(valueOp);
                setValue(valueOp);
                setIsOpen(false);
            }
        }
    }

    const changeInput = (value) => {
        const inputText = value.target.value;
        setValue(inputText);

        const filterOptions = filterAndRankOptions(
            props.options,
            inputText,
            (option) => option.searchTerms || [option.label]
        );

        setSelectOptions(filterOptions);
    }

    const close = (e) => {
        setTimeout(() => {
            setisclose(true);
        }, 300);
    }

    const selectByValue = (value) => {
        if (props.options.value) {
            if (props.options.value === value) {
                onChange(props.options);
            } else if (props.options.value === undefined && props.options.length > 0) {
                props.options.map((op) => {
                    if (op) {
                        if (op.value === value) {
                            onChange(op);
                        }
                    }
                })
            }
        } else {
            props.options.map((op) => {
                if (op) {
                    if (op.value === value) {
                        onChange(op);
                    }
                }
            })
        }
    }

    const solicitarProduto = () => {
        const user = JSON.parse(localStorage.getItem(USER) || '{}');
        const functions = user?.contrato?.agro_plan_functions || [];
        const solicitarFunction = functions.find((f) => f.agro_plan_function_id === 7);

        if (!solicitarFunction) {
            setModalSolicitar(true);
            return;
        }

        if (solicitarFunction.status === 0) {
            setModalBlock(true);
        } else {
            setModalSolicitar(true);
        }
    }

    const solicitarSucesso = () => {
        store.addNotification({
            title: "Sucesso!",
            message: `Produto solicitado com sucesso!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
        setModalSolicitar(false);
    }

    const clear = () => {
        if (value.value) {
            setIsOpen(false);
            props.onChange({ value: '', label: '' });
        } else if (typeof value === 'string') {
            setValue('');
            setIsOpen(false);
            props.onChange({ value: '', label: '' });
            setSelectOptions(props.options)
        }
    }

    const clickArrow = () => {

        if (props.disabled === !true) {
            if (isOpen === true) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
                ref.current.focus();
            }
        } else if (!props.disabled) {
            if (isOpen === true) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
                ref.current.focus();
            }
        } else {

        }
    }

    const onFocusInput = () => {
        if (props.disabled === false || !props.disabled) {
            if (!isOpen) {
                document.getElementById(props.id).select();
            }
            setIsOpen(true);
        }
    }

    const searchGoogleImages = (search) => {
        window.open(`https://www.google.com/search?q=${search}&sxsrf=ALiCzsY0y3LwsxgN0oeayW3_AJMzZFXcng:1657226469380&source=lnms&tbm=isch&sa=X&ved=2ahUKEwjV5ZPY0ef4AhWYpZUCHYKmDtAQ_AUoAXoECAIQAw&biw=1536&bih=792&dpr=1.25`, '_blank');
    }

    const isSolicitarProduto = props.solicitar === true && props.name === 'agro_product_id';
    const isSolicitarProdutor = props.solicitar === true && props.name === 'agro_producer_id';
    const isSolicitarOpcao = isSolicitarProduto || isSolicitarProdutor;
    const solicitarLabel = isSolicitarProdutor ? 'Solicitar produtor' : 'Solicitar produto';
    const displayOptions = Array.isArray(selectOptions)
        ? selectOptions.filter((op) => op && typeof op === 'object' && op.label)
        : [];

    const handleSolicitarOpcao = () => {
        if (isSolicitarProduto) {
            solicitarProduto();
            return;
        }

        if (isSolicitarProdutor && props.onClickAddNew) {
            props.onClickAddNew();
        }
    }

    const handleSolicitarMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(false);
        handleSolicitarOpcao();
    }


    useEffect(() => {
        if (props.options) {
            setSelectOptions(props.options);

            if (props.options.length === 0) {
                setValue('');
            }
        }

        if (props.value != 0 && props.value != undefined && props.value != '') {
            if (props.selectUniqueOption === true) {
                selectByValue(props.value);
            }
        }

        if (props.value || props.value === 0) {
            selectByValue(props.value);
        } else if (props.value === '') {
            setValue('');
        }
    }, [props.options, props.value, props.selectUniqueOption]);

    useEffect(() => {
        if (selectOptions.length > 0) {
            if (selectOptions.length == 1) {
                if (value) {
                    if (selectOptions[0]) {
                        if (value.value != selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                } else {
                    if (selectOptions[0]) {
                        if (selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                }
            }
            setSolicitaP(false)
        } else {
            setSolicitaP(true)
        }

        if (selectOptions.value) {
            if (selectOptions[0] === undefined) {
                setSelectOptions([selectOptions]);
            }
        }
    }, [selectOptions]);

    useEffect(() => {
        if (props.yesNo === true) {
            props.onChangeYesNo(yesNoValue);
        }
    }, [yesNoValue]);

    useEffect(() => {
        setYesNoValue(props.yesNoValue);
    }, [props.yesNoValue])

    useEffect(() => {
        if (props.isOpen) {
            props.isOpen(isOpen);
        }

        if (isOpen) {
            setLimit(20);
        }
    }, [isOpen])

    useEffect(() => {

        if (isclose) {
            if (value && selectOptions.length === 0) {
                setValue('');
                clear();
            } else {
                if (value) {
                    if (selectOptions.length > 1) {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        } else {
                            setValue('');
                            clear();
                        }
                    } else {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        } else {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        }
                    }
                } else {
                    if (props.estado && props.estado.value === "SP") {
                        if (selectOptions.length === 1) {
                            return;
                        }
                    } else {
                        if (selectOptions.length === 1) {
                            onChange(selectOptions[0]);
                        }
                    }
                }
            }

            setTimeout(() => {
                setIsOpen(false);
                setisclose(false)
            }, 300);
        }
    }, [isclose])

    useEffect(() => {
        if (addOptions) {
            let sum = limit + 20;

            if (sum <= selectOptions.length) {
                if (limit !== sum) {
                    setLimit(sum);
                }
            } else {
                if (limit !== selectOptions.length) {
                    setLimit(selectOptions.length);
                }
            }
            setTimeout(() => {
                setAddOptions(false);
            }, 500);
        }
    }, [addOptions]);

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setAddOptions(true);
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        }
    );

    const element = document.querySelector('#loading-options')
    if (element) {
        observer.observe(element);
    }

    return (
        <SelectContainerV2
            isOpen={isOpen}
            erro={props.erro}
            isModal={props.isModal}
            disabled={props.disabled}
            loading={props.loading}
            yesNo={props.yesNo}
            marginBottom={props.marginBottom}
            addNew={props.buttonAddNew}
            buttonDelete={props.buttonDelete}
        >
            <div className="container-Input" style={{
                marginTop: props.buttonAddNew ? '-15px' : '0px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                {props.buttonDelete && (
                    <div 
                        className="clear-button" 
                        style={{
                            position: 'absolute',
                            right: '43px',
                            top: '48%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        onClick={() => {
                            setValue(''); 
                            if (props.onChange) {
                                props.onChange(''); 
                            }
                        }}
                    >
                        <img 
                            src={DeleteIcon} 
                            alt="Clear"
                            style={{
                                width: '10px',
                                height: '10px',
                            }}
                        />
                    </div>
                )}
                
                <div className='select'>
                    <Label
                        erro={props.erro}
                        isFocus={isOpen}
                        existValue={value == '' ? false : true}
                        onClick={() => onFocusInput()}
                        isSearch={props.isSearch}
                        isDisabled={props.disabled}
                        buttonAddNew={props.buttonAddNew}
                        isYesNo={props.yesNo}
                        isModal={props.isModal}
                    >
                        {props.label || props.placeholder}
                    </Label>


                    {props.yesNo === true ? (
                        <>

                            {props.responsive ? (
                                <YesNoContainerMobile responsive={props.responsive} disabled={props.disabled} loading={props.loading}> <span>{props.messageYesNo}</span> <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)} /> </YesNoContainerMobile>

                            ) : (
                                <YesNoContainer
                                    yesNoLeft={props.yesNoLeft}
                                    showDisabled={props.showDisabledYesNo}
                                    disabled={props.disabled}
                                    loading={props.loading}
                                // responsive={props.responsive}
                                >
                                    <span style={{ marginRight: '5px' }}>
                                        {props.messageYesNo}
                                    </span>

                                    <Interruptor
                                        value={yesNoValue}
                                        onChange={(e) => setYesNoValue(e)}
                                    />
                                </YesNoContainer>
                            )}
                        </>
                    ) : (null)}

                    {props.yesNo === true ? (
                        <YesNoContainerMobile disabled={props.disabled} loading={props.loading}> <span>{props.messageYesNo}</span> <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)} /> </YesNoContainerMobile>
                    ) : (null)}

                    {props.isSearch ? (
                            <S.ContainerIconSearch erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                <img
                                    className="delete-select"
                                    src={SearchIcon}
                                    alt='Ícone de pesquisa'
                                    onClick={() => clear()}
                                    width='20px'
                                />
                            </S.ContainerIconSearch>
                        ) : (
                            null
                        )
                    }

                    <input
                        ref={ref}
                        {...props}
                        value={value.label || value || ''}
                        autocomplete='off'
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '0px 65px 0px 40px',
                            borderTopLeftRadius: '25px',
                            borderTopRightRadius: '25px',
                            borderBottomLeftRadius: isOpen ? '0px' : '25px',
                            borderBottomRightRadius: isOpen ? '0px' : '25px',
                            border: props.erro ? `solid 1px ${theme.colors.red.Vermelho_erro}` : 'solid 1px #8A92A2',
                            backgroundColor: "#F8F8F9",
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'regular',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                            letterSpacing: 'normal',
                            color: props.erro ? `${theme.colors.red.Vermelho_erro}` : props.disabled ? '#cfd5df' : '#303848',
                            transition: 'all 0.15s ease-in',
                            position: 'relative',
                        }}
                        onChange={(e) => changeInput(e)}
                        onBlur={(e) => close(e.target)}
                        onFocus={() => onFocusInput()}
                    ></input>
                </div>

                <div className='addnew'>
                    {props.buttonAddNew === true ? (
                        <ButtonAddNew responsive={props.responsive} isModal={props.isModal} onClick={() => props.onClickAddNew()} />
                    ) : (null)}
                </div>
            </div>

            {props.loading === true ? (
                <>
                    <Loading
                        addNew={props.buttonAddNew}
                    />
                </>
            ) : (
                <>
                    {props.disabled === true ? (null) : (
                        <>
                            {/* <Arrow
                                yesNo={props.yesNo}
                                erro={props.erro}
                                isOpen={isOpen}
                                addNew={props.buttonAddNew}
                                isClearable={props.isClearable}
                                disabled={props.disabled}
                                onClick={() => clickArrow()}
                                marginLeft={props.marginLeft}
                            >
                                <img
                                    className="arrow-select"
                                    src={ArrowIcon}
                                    alt='arrow'
                                    onClick={() => clickArrow()}
                                />
                            </Arrow> */}

                            {
                                props.solicitar === true && props.name === 'agro_product_id' ? (
                                    <>
                                        {
                                            solicitaP === true ? (
                                                // <Plus>
                                                //     <p id="msg">Solicitar produto(s)</p>
                                                //     <img
                                                //         className="add-select"
                                                //         src={IconInputClose}
                                                //         alt='add'
                                                //         onClick={() => solicitarProduto()}
                                                //         width='20px'
                                                //     />
                                                // </Plus>
                                                null
                                            ) : (
                                                <>
                                                    {
                                                        props.isClearable ? (
                                                            <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                                <img
                                                                    className="delete-select"
                                                                    src={IconInputClose}
                                                                    alt='delete'
                                                                    onClick={() => clear()}
                                                                    width='20px'
                                                                />
                                                            </Clearabled>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <>
                                        {
                                            props.isClearable ? (
                                                <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                    <img
                                                        className="delete-select"
                                                        src={IconInputClose}
                                                        alt='delete'
                                                        onClick={() => clear()}
                                                        width='20px'
                                                    />
                                                </Clearabled>
                                            ) : (
                                                null
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    )}
                </>
            )}

            {props.help === true ? (
                <div className="help-buttom" onClick={() => props.helpClick()}>
                    <IconHelp
                        fill='#5DA8FD'
                        cursor='pointer'
                    />
                </div>
            ) : (null)}


            {isOpen && (
                <Options isOpen={isOpen} isSearch={props.isSearch} isClearable={props.isClearable} erro={props.erro} marginBottom={props.marginBottom}>
                    {isSolicitarOpcao ? (
                        <Option
                            isSearch={props.isSearch}
                            erro={props.erro}
                            onMouseDown={(e) => handleSolicitarMouseDown(e)}
                            onClick={() => handleSolicitarOpcao()}
                        >
                            <span style={{ color: theme.colors.blue.Azul_link }}>
                                {solicitarLabel}
                            </span>
                        </Option>
                    ) : null}

                    {displayOptions.length > 0 ? (
                        displayOptions.map((op, i) => (
                            op && i < limit && (
                                <Option
                                    isSearch={props.isSearch}
                                    key={`op_${op.value}_${i}`}
                                    erro={props.erro}
                                    onClick={() => onChange(op)}
                                >
                                    {renderOptionLabel(op)}
                                    {op.label && props.searchPhoto ? (
                                        <div
                                            className="button-foto"
                                            style={{
                                                width: '90px',
                                                minWidth: '90px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-evenly',
                                                alignItems: 'center',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Button
                                                width='90px'
                                                value='Detalhes'
                                                outline={true}
                                                disabled={false}
                                                onClick={() => props.onDossie ? props.onDossie(op) : searchGoogleImages(op.label)}
                                                loading={false}
                                            />
                                        </div>
                                    ) : null}

                                    {i === (limit - 3) && (
                                        <div id='loading-options'></div>
                                    )}
                                </Option>
                            )
                        ))
                    ) : (
                        <>
                            <NoOptions>
                                Não há resultados
                            </NoOptions>
                        </>
                    )}

                </Options>
            )}

            {props.erro && props.messageErro ? (
                <Legenda>{props.messageErro}</Legenda>
            ) : (<>
                {props.legenda && (
                    <Legenda>{props.legenda}</Legenda>
                )}
            </>)}

            <ModalAlert
                show={showModalSolicitar}
                onHide={() => setModalSolicitar(false)}
                title="Solicitar Produto"
                size='lg'
            >
                <p style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '22px',
                    fontWeight: 'bold'
                }}>Solicitar um ou mais produto(s)</p>

                <Solicitar isModal={true} closeModalS={() => solicitarSucesso()} />
            </ModalAlert>

            <ModalAlert
                show={showModalBlock}
                onHide={() => setModalBlock(false)}
                title="Solicitar Produto"
            >
                <p style={{
                    fontFamily: 'Lato',
                    fontSize: '22px',
                    fontWeight: 'bold',
                    fontStretch: 'normal',
                    width: '100%',
                    textAlign: 'center',
                    alignSelf: 'center'
                }}>
                    Essa função não está liberada para o seu plano
                </p>

                <div
                    style={{
                        color: '#303848',
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        fontWeight: 'normal',
                        width: '100%',
                        textAlign: 'center',
                        alignSelf: 'center'
                    }}
                >
                    <p style={{
                        color: '#303848',
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        fontWeight: 'normal',
                        width: '100%',
                        textAlign: 'center',
                        alignSelf: 'center'
                    }}>
                        Faça um upgrade para desbloquear esse recurso
                    </p>

                    <div
                        style={{
                            width: '100%',
                            maxWidth: '350px',
                            margin: 'auto',
                            marginTop: '20px',
                            alignSelf: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            width='296px'
                            height='50px'
                            value='VER PLANOS'
                            outline={false}
                            disabled={false}
                            onClick={() => {
                                setModalBlock(false);
                                window.location = '/planos';
                            }}
                            loading={false}
                        />
                    </div>
                </div>
            </ModalAlert>
        </SelectContainerV2>
    );
}

export default SelectV2StepOne;
